import { useEffect, useCallback } from 'react'
import { analytics } from 'src/Analytics'
import MixpanelAnalyticsTracker from 'src/Analytics/MixpanelAnalyticTracker'

type AppSideMessage = {
  isNativeApp: string
  mixpanelDistinctId: string
  whiteLabelKey: string
  whiteLabelName: string
  appBrandingKey: string
  appBrandingName: string
  appInstallId: string
  analyticConsent: string
  buildMode: string
  isLiveHelpFeatureEnabled: string
}

export const MessageEventHandler = () => {
  const onMessageReceived = useCallback((event: any) => {
    try {
      const nativeApp: AppSideMessage = JSON.parse(event.data)
      localStorage.setItem('isNativeApp', nativeApp.isNativeApp)
      if (localStorage.getItem('isLiveHelpFeatureEnabled') !== 'true') {
        localStorage.setItem(
          'isLiveHelpFeatureEnabled',
          nativeApp.isLiveHelpFeatureEnabled
        )
      }
      if (nativeApp.analyticConsent === 'true') {
        const mixpanelAnalyticsTracker = new MixpanelAnalyticsTracker(
          nativeApp.buildMode
        )
        analytics.setTrackers([mixpanelAnalyticsTracker])
        mixpanelAnalyticsTracker.identify(nativeApp.mixpanelDistinctId)

        mixpanelAnalyticsTracker.updateProperties(
          'White labeled app key',
          nativeApp.whiteLabelKey
        )
        mixpanelAnalyticsTracker.updateProperties(
          'White labeled app',
          nativeApp.whiteLabelName
        )
        mixpanelAnalyticsTracker.updateProperties(
          'Application branding key',
          nativeApp.appBrandingKey
        )
        mixpanelAnalyticsTracker.updateProperties(
          'Application branding',
          nativeApp.appBrandingName
        )
        mixpanelAnalyticsTracker.updateProperties(
          'App install id',
          nativeApp.appInstallId
        )
      }
    } catch (error) {}
  }, [])

  useEffect(() => {
    document.addEventListener('message', onMessageReceived)
    window.addEventListener('message', onMessageReceived)
    return () => {
      document.removeEventListener('message', onMessageReceived)
      window.removeEventListener('message', onMessageReceived)
    }
  }, [onMessageReceived])
}
